import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import { useDispatch, useSelector } from 'react-redux';
import { addItem } from '../reduxAuth/cartSlice';
import { FaExclamationCircle } from 'react-icons/fa';

function SingleTour() {
  const {user}                                                                        = useSelector((state) => state.auth);
  const params                                                             = useParams();
  const [currentTour, setCurrentTour]                                      = useState();
  const [currentQty, setCurrentQty]                                        = useState(1);

  const [currentPricing, setCurrentPricing]                                = useState("public");

  const dispatch                                                           = useDispatch();

  useEffect(() => {
    collectSingleTour();
    document.title = 'Tour | Stephenson Adventures';
  },[])

  const collectSingleTour = async () => {
    try{
      
      const resTour = await axios.get(CONSTANTS.API_URL +"tours/details/" + params.id, {
            headers: {
              api_key: CONSTANTS.TOKEN_APIKEY
            }
        }); 
        console.log(resTour.data);
        setCurrentTour(resTour.data);
    }catch(err){
      console.log(err);
    }
  }

  const handleQuantityUpdate = (calc) => {
    if(calc === "+"){
      setCurrentQty(num => num + 1);
    }else {
      if(currentQty > 1){
        setCurrentQty(num => num - 1)
      }
    }
  }

  const handleAddToCart = () => {
    //dispatch(addItem(currentTour)); // Dispatch the action to add the product to the cart
    dispatch(addItem({...currentTour, quantity: currentQty }))
  };

 
  const handlePricingChange = (event)  => {
    setCurrentPricing(event.target.value);
  }
  return (
    <div className="standard-ountline">
        <div className="standard-area">SingleTour
        {
          currentTour && (
            <div className="container">
              <div className="row rw">
                <div className="col-md-5">
                      <div className="image-area-block">
                          <div className="central-image">
                            <img src={currentTour.img_url} className="image-main" />
                          </div>
                          <div className="strip-image"></div>
                      </div> 
                </div>
                <div className="col-md-4">
                  <div className="cont-product-item ctprod-1">
                    <h3>{currentTour.name}</h3>
                    <div className="desc">
                        {currentTour.description}
                    </div>
                    <div className="bulk-declar">

                    </div>
                    <div className="buttons-listing">
                       <div className="small-title">Quantity</div>
                       <div className="items-list-check flexme">
                          <button className="btn btn-introvet-small" onClick={() => handleQuantityUpdate("-")}> - </button>
                          <div className="num-input">
                             {currentQty}
                          </div>
                          <button className="btn btn-introvet-small" onClick={() => handleQuantityUpdate("+")}> + </button>
                          <div className="discount-information">
                              <div className="discount-middle">
                              Discount price is <strong>R {parseInt(currentTour.discount).toFixed(2)} for 2 or more people.</strong>
                              </div>
                          </div>
                       </div>
                       <div className="items-list-check ">
                         <button className="btn btn-activator btn-full" onClick={handleAddToCart}>
                            ADD TO CART
                          </button>
                       </div>
                       
                        {
                          user && (<div className="items-list-check "> 
                                    <button className="btn btn-introvet btn-full">ADD TO FAVOURITES</button>
                                   </div>)
                        }                        
                       
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="cont-product-item ctprod-2">
                    
                    <div className="price-content">
                       <h4>Pricing</h4>
                       <div className="label-radio">
                          <input 
                            type="radio"
                            value="public"
                            checked={currentPricing === "public"}
                            onChange={handlePricingChange}
                            />
                            <span className="sebedi-bap">Public Pricing</span>
                       </div>
                       <div className="label-radio">
                          <input 
                            type="radio"
                            value="private"
                            checked={currentPricing === "private"}
                            onChange={handlePricingChange}
                            />
                            <span className="sebedi-bap">Private Pricing</span>
                       </div>

                       {
                         currentPricing === "public" ? 
                            <div className="pricing-time ">
                              <span className="rg"><FaExclamationCircle /></span>
                              <span >R {parseInt(currentTour.group_price).toFixed(2)}</span> 
                              <div className="tooling">
                                  Pricing for you or your group to get a <strong>group</strong> tour.
                              </div>
                            </div>
                          :
                            <div className="pricing-time">
                              <span className="rg"><FaExclamationCircle /></span>
                              <span >R {parseInt(currentTour.price).toFixed(2)}</span>
                              <div className="tooling">
                                 Pricing for you or your group to get a <strong>private</strong> tour.
                              </div>
                            </div>                            
                       }
                    </div>
                  </div>
                </div>
              </div>
              <div className="row rw second-strip">
                 <div className="col-md-4">
                    {
                      currentTour.brochure_download && (
                        <div className="pd-vertal">
                          <div className="small-title">Brochure</div>
                          <Link to={currentTour.brochure_download} target="_blank">Download Brochure</Link>
                        </div>
                      )
                    }
                    
                    <div className="pd-vertal">
                        <div className="small-title">Itinerary</div>
                        <div className="item-title">{currentTour.itinerary_line}</div>
                        <div className="listing-title">
                            <ul>
                              {currentTour.itinerary.map((item, index) => {
                                return <li key={index}>{item}</li>
                              })}
                            </ul>  
                        </div>
                    </div>
                      
                 </div>
              </div>
           </div>
          )                        
        }           
        </div>
     </div>
  )
}

export default SingleTour